import React from 'react'

export default function VisiGiftDeactivateCampaign() {
  return (
    <div>VisiGiftDeactivateCampaign</div>
  )
}
